<template>
    <div class="settingsContainer">
        <div class="settingsWrapper">
            <div class="title">
                Account Settings
            </div>

            <div class="tabs">
                <v-tabs v-model="tab" class="d-flex" grow>
                    <v-tab v-for="item in items" :key="item">
                        {{ item }}
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <settings />
                    </v-tab-item>
                    <v-tab-item>
                        <VirtualAccountInfo/>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </div>
        <!-- <h5 style="font-size:22px">Settings</h5>
        <v-tabs v-model="tab" class="d-flex justify-center">
            <v-tab v-for="item in items" :key="item">
                {{ item }}
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <settings />
            </v-tab-item>
            <v-tab-item>
                ORPHANS
            </v-tab-item>
        </v-tabs-items> -->
    </div>
</template>

<script>
import Settings from '../components/dashboard/Settings.vue'
import VirtualAccountInfo from '../components/dashboard/virtualAccountInfo.vue'

export default {
    name: 'SettingsView',
    components: {
        Settings,
        VirtualAccountInfo
    },
    data () {
        return {
            tab: 0,
            items: ['Basic Details', 'Virtual Account']
        }
    }
}
</script>

<style scoped lang="scss">

.settingsContainer {
    display: flex;
    justify-content: center;
    align-items: center;

    .settingsWrapper {
        width: 50%;
    }

    .title {
        padding: 48px 12px;
    }
}

@media (max-width: 800px) {
    .settingsContainer {
        .settingsWrapper {
            width: 100%;

            ::v-deep .v-item-group {
                flex: 1 !important
            }
        }

        .title {
            padding: 24px;
        }
    }
}
</style>
